module.exports = __webpack_public_path__ + "static/media/7.00f69bbb.jpg";